<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import validations, { getLabelTitleErrorMessage } from './validations';
import { getRandomColor } from 'dashboard/helper/labelColor';
import { useVuelidate } from '@vuelidate/core';
import LabelSearchInput from './LabelSearchInput.vue';

export const labelTypeOptions = Object.freeze([
  { id: 'Pre-Sale', name: 'Pre Sale' },
  { id: 'Post-Sale', name: 'Post Sale' },
]);

export default {
  components: {
    LabelSearchInput,
  },
  props: {
    prefillTitle: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      color: '#000',
      description: '',
      // title: '',
      labelName: {
        l1_label: '',
        l2_label: '',
        l3_label: '',
      },
      labelType: 'Pre-Sale',
      showOnSidebar: true,
      labelTypeOptions,
    };
  },
  validations,
  computed: {
    ...mapGetters({
      uiFlags: 'labels/getUIFlags',
    }),
    labelTitleErrorMessage() {
      const errorMessage = getLabelTitleErrorMessage(this.v$);
      return this.$t(errorMessage);
    },
  },
  mounted() {
    this.color = getRandomColor();
    // this.title = this.prefillTitle.toLowerCase();
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    async addLabel() {
      try {
        // 先校验 LabelSearchInput 组件
        const labelSearchInputRef = this.$refs.labelSearchInput;
        if (labelSearchInputRef) {
          const isValid = await labelSearchInputRef.validate();
          if (!isValid) {
            return; // 校验失败，不继续执行
          }
        }
        // 格式化标签名称
        const formatLabel = (label) => {
          if (!label) return '';
          return label.trim()
            // .replace(/\s+/g, '_')
            // .toLowerCase();
        };

        await this.$store.dispatch('labels/create', {
          color: this.color,
          description: this.description,
          // title: this.title.toLowerCase(),
          l1_label: formatLabel(this.labelName.l1_label),
          l2_label: formatLabel(this.labelName.l2_label),
          l3_label: formatLabel(this.labelName.l3_label),
          label_type: this.labelType,
          show_on_sidebar: this.showOnSidebar,
        });
        useAlert(this.$t('LABEL_MGMT.ADD.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        const errorMessage =
          error.message || this.$t('LABEL_MGMT.ADD.API.ERROR_MESSAGE');
        useAlert(errorMessage);
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="$t('LABEL_MGMT.ADD.TITLE')"
      :header-content="$t('LABEL_MGMT.ADD.DESC')"
    />
    <form class="flex flex-wrap mx-0" @submit.prevent="addLabel">
      <!-- <woot-input
        v-model="title"
        :class="{ error: v$.title.$error }"
        class="w-full label-name--input"
        :label="$t('LABEL_MGMT.FORM.NAME.LABEL')"
        :placeholder="$t('LABEL_MGMT.FORM.NAME.PLACEHOLDER')"
        :error="labelTitleErrorMessage"
        data-testid="label-title"
        @input="v$.title.$touch"
        @blur="v$.title.$touch"
      /> -->
      <LabelSearchInput 
        ref="labelSearchInput"
        v-model="labelName" 
      />

      <!-- <SingleSelect v-model="labelType" :options="options" disable-search /> -->
      <label class="w-full">
        * {{ $t('LABEL_MGMT.FORM.LABEL_TYPE.LABEL') }}
        <select v-model="labelType">
          <option v-for="option in labelTypeOptions" :key="option.id" :value="option.id">
            {{ option.name }}
          </option>
        </select>
      </label>

      <woot-input
        v-model="description"
        :class="{ error: v$.description.$error }"
        class="w-full"
        :label="`* ${$t('LABEL_MGMT.FORM.DESCRIPTION.LABEL')}`"
        :placeholder="$t('LABEL_MGMT.FORM.DESCRIPTION.PLACEHOLDER')"
        data-testid="label-description"
        @input="v$.description.$touch"
        @blur="v$.description.$touch"
      />

      <div class="w-full">
        <label>
          {{ $t('LABEL_MGMT.FORM.COLOR.LABEL') }}
          <woot-color-picker v-model="color" />
        </label>
      </div>
      <div class="flex items-center w-full gap-2">
        <input v-model="showOnSidebar" type="checkbox" :value="true" />
        <label for="conversation_creation">
          {{ $t('LABEL_MGMT.FORM.SHOW_ON_SIDEBAR.LABEL') }}
        </label>
      </div>
      <div class="flex items-center justify-end w-full gap-2 px-0 py-2">
        <woot-button
          :is-disabled="uiFlags.isCreating"
          :is-loading="uiFlags.isCreating"
          data-testid="label-submit"
        >
          {{ $t('LABEL_MGMT.FORM.CREATE') }}
        </woot-button>
        <woot-button class="button clear" @click.prevent="onClose">
          {{ $t('LABEL_MGMT.FORM.CANCEL') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>
